import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import fetch from 'isomorphic-fetch'; // required for ApolloClient initialization in test env

const httpLink = createHttpLink({
  uri: `${process.env.MONOLITH_HOST_URL}/api/metadata/graph`,
  fetch,
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

export default client;
